import { Line } from "@react-three/drei";
import { Box } from "@react-three/flex";
import GeoFlex from "../Flexes/GeoFlex";
import ImgFlex from "../Flexes/ImgFlex";
import TxtFlex from "../Flexes/TxtFlex";

function FaceSpaceBox({ 
  align, 
  scale, 
  handleThreshold, 
  viewport,
  txtOne
}) {

  return(
    <>
    <Box
      flexDirection='column' 
      align={align} 
      justify='flex-end'
      width='100%'
      // height='60%'
      // wrap='wrap'
      margin={scale}
      flexGrow={scale}
      marginLeft={8 * scale}
      >
      <Box
        marginLeft={2 * scale}
        marginBottom={6 * scale}
      >
        <ImgFlex
          scale={scale}
          onReflow={handleThreshold}
          align='center'
          justify='center'
          image='/pictures/FS_SS_v2.PNG'
          viewport={viewport}
          txtOne={txtOne}
          // txtTwo={'Designer\n Musician\n'}
          txtColorOne='#7E0000'
          txtColorTwo='gold'
          textScaleFactor={1.025 * scale}
          textAlign='left'
        />
      </Box>
      <Box
        // margin={scale}
        marginLeft={7 * scale}
        // padding={scale}
      >
        <TxtFlex 
          scale={scale}
          onReflow={handleThreshold}
          align='center'
          justify='center'
          txtColorOne='white'
          txtColorTwo='white'
          textScaleFactor={scale * 0.45}
          textAlign='right'
          text={
            `
            faceSpace is the anti-social social network.\n 
            Server side social media/e-commerce back end build.\n
            Heavy hand in project managment.\n 
            Structured E.R.D for smooth implementation of SQL tables.\n
            Provided more involved data aggregation for models layer.\n
            Pair programmed Oauth implementation.\n


            
            6 day sprint, 4 developers.`
          }
          />
        </Box>
    </Box>    
    </>
  );
};

export default FaceSpaceBox;